import React, { useState, useEffect } from "react";
import {
    Input,
    Segment,
    Select,
    Label,
    Dropdown,
    Button,
    AccordionTitle,
    AccordionContent,
    Accordion,
    Icon,
    Message,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styles from "./index.module.scss";
import { Tabs, Tab } from "react-bootstrap";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";
import Notes from "../../assets/components/Notes";
import NotificationActions from "../../store/actions/notification";
import ValidationActions from "../../store/actions/validation";
import TeeTimeBooking from "../../models/TeeTimeBooking";
import GolfClub from "../../models/GolfClub";
import GolfCourse from "../../models/GolfCourse";
import User from "../../models/User";
import CenterLoader from "../../assets/components/CenterLoader";
import NumberInput from "../../assets/components/NumberInput";
import GolfClubSearchSelect from "../../assets/components/GolfClubSearchSelect";
import ValidationError from "../../assets/components/ValidationError";
import formatNumberAsPrice from "../../utilities/formatNumberAsPrice";
import { format, formatDistanceToNow } from "date-fns";
import CourseAvailabilityCalendar from "../../assets/components/golfClub/CourseAvailabilityCalendar";
import MemberChip from "../../assets/components/MemberChip";
import DataTable from "../../assets/components/dataTable";

const Show = ({ user, history, match, dispatch }) => {
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [customerNotes, setCustomerNotes] = useState([]);
    const [internalNotes, setInternalNotes] = useState([]);
    const [booking, setBooking] = useState(null);
    const [confirmedClub, setConfirmedClub] = useState(null);
    const [courses, setCourses] = useState([]);
    const [nearby, setNearby] = useState([]);
    const [availableContracts, setAvailableContracts] = useState([]);
    const [availableContractsExplain, setAvailableContractsExplain] = useState(
        [],
    );
    const [activeAccordion, setActiveAccordion] = useState(-1);
    const [showConfirmedBookingEditor, setShowConfirmedBookingEditor] =
        useState(false);
    const [addingConfirmedBooking, setAddingConfirmedBooking] = useState(false);

    const [
        confirmedOverrideAvailableDates,
        setConfirmedOverrideAvailableDates,
    ] = useState(false);

    const [quoteLoading, setQuoteLoading] = useState(false);
    const [quoteError, setQuoteError] = useState(null);
    const [quoteValid, setQuoteValid] = useState(false);
    const [quoteNotice, setQuoteNotice] = useState(null);
    const [quoteAttempted, setQuoteAttempted] = useState(false);

    const quoteSeqRef = React.useRef(0);
    const quoteNoticeTimerRef = React.useRef(null);
    const quoteLoadingStartedAtRef = React.useRef(null);

    const [quoteMeta, setQuoteMeta] = useState(null);

    const statuses = [
        {
            key: 0,
            text: "Requested by member",
            value: "requested",
        },
        {
            key: 2,
            text: "Awaiting member confirmation",
            value: "awaiting confirmation",
        },
        {
            key: 3,
            text: "Confirmed by member",
            value: "confirmed",
        },
        {
            key: 4,
            text: "Booked by MASHIE",
            value: "booked",
        },
        {
            key: 5,
            text: "Cancellation requested by member",
            value: "cancellation requested",
        },
        {
            key: 6,
            text: "Cancelled by MASHIE",
            value: "cancelled",
        },
    ];

    const paymentStatuses = [
        {
            key: 0,
            text: "Unpaid",
            value: "unpaid",
        },
        {
            key: 1,
            text: "Pay MASHIE Now",
            value: "pay mashie now",
        },
        {
            key: 2,
            text: "Pay club Now",
            value: "pay club now",
        },
        {
            key: 3,
            text: "Pay club on arrival",
            value: "pay club on arrival",
        },
        {
            key: 4,
            text: "Paid",
            value: "paid",
        },
        {
            key: 5,
            text: "No payment required",
            value: "no payment required",
        },
        {
            key: 6,
            text: "Refunded",
            value: "refunded",
        },
    ];

    const cancellationReasons = [
        {
            key: 0,
            text: "No availability at club",
            value: "no availability at club",
        },
        {
            key: 1,
            text: "Member cancelled",
            value: "member cancelled",
        },
        {
            key: 2,
            text: "No response from member",
            value: "no response from member",
        },
        {
            key: 3,
            text: "No payment made",
            value: "no payment made",
        },
        {
            key: 4,
            text: "Cancelled by club",
            value: "cancelled by club",
        },
    ];

    const statusDescriptions = {
        requested:
            "This booking has been requested by the member and not yet actioned by MASHIE.",
        "awaiting confirmation":
            "This booking has been actioned in part by MASHIE, and is now awaiting confirmation from the member.",
        confirmed:
            "The member has confirmed they are happy with the booking offered by MASHIE.",
        booked: "MASHIE has made the booking with the club. No further action is required.",
        "cancellation requested":
            "The member has requested to cancel their booking.",
        cancelled:
            "This booking has been cancelled by MASHIE. No further action is required.",
    };

    useEffect(() => {
        getBooking();
        getCustomerNotes();
        getInternalNotes();
    }, []);

    const notification = (type, text) => {
        dispatch(NotificationActions.create({ type, text }));
    };

    const handleValidationErrors = (error) => {
        if (error.response.status === 422) {
            dispatch(ValidationActions.create(error.response.data.errors));
        }
    };

    const getBooking = async () => {
        const { id } = match.params;
        try {
            const booking = await TeeTimeBooking.getById(id);
            booking.user = new User(booking.user);
            let nearby = [];
            if (booking.isCreditBooking === false) {
                nearby = await new GolfClub(
                    booking.choices[0].course.club,
                ).nearby();
            }

            let courses = [];
            if (booking.hasConfirmedBooking === true) {
                const club = await GolfClub.show(
                    booking.confirmedBooking.course.club._id,
                );
                courses = await club.coursesIndex({
                    sort: "name",
                });

                setCourses(courses);
                setConfirmedClub(club);
            }

            setBooking(booking);
            setShowConfirmedBookingEditor(booking.hasConfirmedBooking === true);
            setNearby(nearby);
            const contracts = await booking.getAvailableContracts();
            setAvailableContracts(contracts);
            const contractsExplain =
                await booking.getAvailableContractsExplain();
            setAvailableContractsExplain(contractsExplain);
        } catch (error) {
            notification("error", "Failed to entity, please try again");
        }
        setLoading(false);
    };

    const getCustomerNotes = async () => {
        const { id } = match.params;
        const notes = await TeeTimeBooking.getCustomerNotes(id);
        setCustomerNotes(notes);
    };

    const getInternalNotes = async () => {
        const { id } = match.params;
        const notes = await TeeTimeBooking.getInternalNotes(id);
        setInternalNotes(notes);
    };

    const parseHourFromTimeValue = (t) => {
        if (!t || typeof t !== "string") return null;
        // accepts "12:04" or "12:00 - 12:59" etc
        const hh = t.split(":")[0];
        const hour = parseInt(hh, 10);
        return Number.isFinite(hour) && hour >= 0 && hour <= 23 ? hour : null;
    };

    const getQuoteMethodForFlow = () => {
        // Voucher flow: contract => creditQuote, otherwise quote
        if (booking?.voucher) {
            return booking.contract ? "creditQuote" : "quote";
        }
        // Credit flow
        if (booking?.isCreditBooking === true || booking?.contract) {
            return "creditQuote";
        }
        // Cash flow
        return "quote";
    };

    const showQuoteNoticeFor = (text, ms = 5000) => {
        setQuoteNotice(text);

        if (quoteNoticeTimerRef.current) {
            clearTimeout(quoteNoticeTimerRef.current);
        }

        quoteNoticeTimerRef.current = setTimeout(() => {
            setQuoteNotice(null);
            quoteNoticeTimerRef.current = null;
        }, ms);
    };

    useEffect(() => {
        return () => {
            if (quoteNoticeTimerRef.current)
                clearTimeout(quoteNoticeTimerRef.current);
        };
    }, []);

    const getCreditAdjustmentInfo = () => {
        const club = getActiveConfirmedClub();
        const currencySymbol =
            club?.currency?.symbol ?? booking?.currency?.symbol ?? "£";

        const isCreditNoVoucher =
            booking?.isCreditBooking === true && booking?.voucher === null;

        if (!isCreditNoVoucher) {
            return { show: false };
        }

        const currentBalance = Number(booking?.user?.teeTimeCreditBalance ?? 0);
        const creditPaid = Number(booking?.creditPaid ?? 0);
        const newPrice = Number(booking?.confirmedBooking?.price ?? 0);

        // +ve => refund, -ve => charge
        const priceDifference = Number((creditPaid - newPrice).toFixed(2));
        const newTeeTimeBalance = Number(
            (currentBalance + priceDifference).toFixed(2),
        );

        const isRefund = priceDifference > 0;
        const isCharge = priceDifference < 0;

        const priceDiffAbs = Math.abs(priceDifference);

        if (priceDifference === 0) {
            return { show: false };
        }

        const priceDifferenceText = isRefund
            ? `Refund: ${currencySymbol}${formatNumberAsPrice(priceDiffAbs)}`
            : `Charge: ${currencySymbol}${formatNumberAsPrice(priceDiffAbs)}`;

        const newBalanceText = `${currencySymbol}${formatNumberAsPrice(
            newTeeTimeBalance,
        )}`;

        return {
            show: true,
            priceDifference,
            newTeeTimeBalance,
            canProcess: newTeeTimeBalance >= 0,
            priceDifferenceText,
            newBalanceText,
            currencySymbol,
        };
    };

    const attemptQuoteForConfirmedBooking = async (nextBooking) => {
        const b = nextBooking ?? booking;
        if (!b?.confirmedBooking) return;

        // Only quote when not overriding
        if (confirmedOverrideAvailableDates === true) return;

        const course = b.confirmedBooking.course;
        if (!course?._id) return;

        const dateObj = b.confirmedBooking.date
            ? new Date(b.confirmedBooking.date)
            : null;
        const timeValue = b.confirmedBooking.time;

        if (!dateObj || !timeValue) return;

        const hour = parseHourFromTimeValue(timeValue);
        if (hour === null) return;

        const day = dateObj.getDate();
        const month = dateObj.getMonth() + 1; // 1-12
        const year = dateObj.getFullYear();

        const players = b.confirmedBooking.players ?? b.players ?? 1;
        const member = b.user?._id;
        const voucher = b.voucher?._id ?? null;
        const bookingId = b._id ?? null;

        // safety
        if (!member) return;

        const seq = ++quoteSeqRef.current;

        quoteLoadingStartedAtRef.current = Date.now();
        setQuoteAttempted(true);
        setQuoteLoading(true);
        setQuoteError(null);
        setQuoteMeta(null);

        try {
            const method = getQuoteMethodForFlow();

            const res =
                method === "creditQuote"
                    ? await GolfCourse.creditQuote(
                          course._id,
                          day,
                          month,
                          year,
                          hour,
                          players,
                          member,
                          voucher,
                          bookingId,
                      )
                    : await GolfCourse.quote(
                          course._id,
                          day,
                          month,
                          year,
                          hour,
                          players,
                          member,
                          voucher,
                          bookingId,
                      );

            // ignore stale responses
            if (seq !== quoteSeqRef.current) return;

            setQuoteValid(true);

            // Update confirmed booking pricing for CASH/CREDIT only (not voucher)
            const isVoucherFlow = !!b.voucher;
            const isCreditFlow =
                !isVoucherFlow &&
                (b.isCreditBooking === true || b.contract !== null);

            // “Price may have changed” notice if it differs from current values
            if (!isVoucherFlow) {
                if (method === "quote") {
                    const nextPrice = res?.discountedTotal ?? 0;
                    const nextFee = res?.bookingFeeTotal ?? 0;

                    const changed =
                        b.confirmedBooking.price !== nextPrice ||
                        b.confirmedBooking.bookingFee !== nextFee;

                    b.confirmedBooking.price = nextPrice;
                    b.confirmedBooking.bookingFee = nextFee;

                    if (changed) {
                        showQuoteNoticeFor(
                            "IMPORTANT: Prices may have been updated.",
                            5000,
                        );
                    } else {
                        setQuoteNotice(null);
                    }
                } else {
                    // creditQuote
                    // creditQuote extras (only present when bookingId sent + booking is credit/no-voucher server-side)
                    if (
                        typeof res?.priceDifference === "number" &&
                        typeof res?.newTeeTimeBalance === "number"
                    ) {
                        setQuoteMeta({
                            priceDifference: res.priceDifference,
                            newTeeTimeBalance: res.newTeeTimeBalance,
                        });
                    }

                    const nextPrice = res?.discountedTotal ?? 0;

                    const changed = b.confirmedBooking.price !== nextPrice;

                    b.confirmedBooking.price = nextPrice;
                    // credit bookings don’t use booking fee here
                    b.confirmedBooking.bookingFee =
                        b.confirmedBooking.bookingFee ?? 0;

                    if (changed) {
                        showQuoteNoticeFor(
                            "IMPORTANT: Prices may have been updated.",
                            5000,
                        );
                    } else {
                        setQuoteNotice(null);
                    }
                }

                setBooking(new TeeTimeBooking(b));
            } else {
                // Voucher flow: only validity matters
                setQuoteNotice(null);
            }
        } catch (error) {
            if (seq !== quoteSeqRef.current) return;

            setQuoteValid(false);
            setQuoteError(
                "The current date and time selection is no longer valid for this club.",
            );
            setQuoteNotice(null);
        } finally {
            if (seq !== quoteSeqRef.current) return;

            const MIN_LOADING_MS = 1500;
            const startedAt = quoteLoadingStartedAtRef.current;
            const elapsed = startedAt ? Date.now() - startedAt : MIN_LOADING_MS;

            const remaining = Math.max(0, MIN_LOADING_MS - elapsed);

            setTimeout(() => {
                // ensure nothing newer started
                if (seq === quoteSeqRef.current) {
                    setQuoteLoading(false);
                }
            }, remaining);
        }
    };

    const onChangeConfirmedOverride = (override) => {
        const nextOverride = override === true;

        setConfirmedOverrideAvailableDates(nextOverride);

        // Reset quote state whenever override changes
        setQuoteLoading(false);
        setQuoteError(null);
        setQuoteNotice(null);
        setQuoteMeta(null);

        // If override is ON, we don't require quote validity
        if (nextOverride === true) {
            setQuoteValid(false);
            return;
        }

        // If override just got turned OFF, try to re-quote if we have date + time
        attemptQuoteForConfirmedBooking(booking);
    };

    const addConfirmedBooking = async () => {
        try {
            setAddingConfirmedBooking(true);

            const clubId = booking.choices?.[0]?.course?.club?._id;

            // If we can't load club/courses, just open the editor with defaults immediately
            if (!clubId) {
                booking.confirmedBooking =
                    buildDraftConfirmedBookingFromDefaults();
                setBooking(new TeeTimeBooking(booking));
                setShowConfirmedBookingEditor(true);
                return;
            }

            const club = await GolfClub.show(clubId);
            const courses = await club.coursesIndex({ sort: "name" });

            setConfirmedClub(club);
            setCourses(courses);

            // Only now show the editor + draft
            booking.confirmedBooking = buildDraftConfirmedBookingFromDefaults();
            setBooking(new TeeTimeBooking(booking));
            setShowConfirmedBookingEditor(true);
        } catch (error) {
            notification(
                "error",
                "Failed to load club/courses for confirmed booking",
            );
        } finally {
            setAddingConfirmedBooking(false);
        }
    };

    const onChangeStatus = (value) => {
        booking.status = value;
        if (value !== "cancelled") {
            booking.cancellationReason = null;
        }
        setBooking(new TeeTimeBooking(booking));
    };

    const onChangeCancellationReason = (value) => {
        booking.cancellationReason = value || null;
        setBooking(new TeeTimeBooking(booking));
    };

    const onChangePaymentStatus = (value) => {
        booking.paymentStatus = value;
        setBooking(new TeeTimeBooking(booking));
    };

    const save = async () => {
        setSaving(true);
        try {
            await booking.update();
            dispatch(ValidationActions.remove());
            notification("success", "Tee time request saved");

            await getBooking(); // ✅ refresh whole state from server
        } catch (error) {
            notification("error", "Failed to save Tee time request");
            handleValidationErrors(error);
        }
        setSaving(false);
    };

    const clubContacts = (club) => {
        return club.contacts.map((contact, index) => {
            return (
                <div className={styles.contact} key={index}>
                    <p>
                        <b>Name:</b> {contact.name}
                    </p>
                    <p>
                        <b>Position:</b> {contact.position}
                    </p>
                    <p>
                        <b>email:</b> {contact.email}
                    </p>
                    <p>
                        <b>phone:</b> {contact.phone}
                    </p>
                </div>
            );
        });
    };

    const onChangeConfirmedDate = (selectedDay) => {
        selectedDay.setHours(12);
        booking.confirmedBooking.date = selectedDay;
        const next = new TeeTimeBooking(booking);
        setBooking(next);
        attemptQuoteForConfirmedBooking(booking);
    };

    const onChangeConfirmedTime = (value) => {
        booking.confirmedBooking.time = value;
        const next = new TeeTimeBooking(booking);
        setBooking(next);
        attemptQuoteForConfirmedBooking(booking);
    };

    const onChangeConfirmedPlayers = (value) => {
        const limits = getPlayersLimitsForFlow();

        // Voucher players are fixed
        if (booking.voucher) return;

        const nextPlayers = Math.min(
            Math.max(value ?? limits.min, limits.min),
            limits.max,
        );

        booking.confirmedBooking.players = nextPlayers;

        const next = new TeeTimeBooking(booking);
        setBooking(next);

        // Only quotes when: course selected, date+time selected, override is off (guarded inside)
        attemptQuoteForConfirmedBooking(booking);
    };

    const onChangePaymentLink = (value) => {
        booking.paymentLink = value === "" ? null : value;
        setBooking(new TeeTimeBooking(booking));
    };

    const onChangeConfirmedPrice = (value) => {
        booking.confirmedBooking.price = value;
        setBooking(new TeeTimeBooking(booking));
    };

    const onChangeConfirmedBookingFee = (value) => {
        booking.confirmedBooking.bookingFee = value || "";
        setBooking(new TeeTimeBooking(booking));
    };

    const onChangeConfirmedClub = async (value) => {
        const club = await GolfClub.show(value);
        const courses = await club.coursesIndex({ sort: "name" });

        // Reset course to "Please choose" (null)
        booking.confirmedBooking.course = null;

        // Clamp players to new club cash limits (cash only)
        const min = club?.bookingCashMinPlayers ?? 1;
        const max = club?.bookingCashMaxPlayers ?? 100;
        const current = booking?.confirmedBooking?.players ?? min;
        booking.confirmedBooking.players = Math.min(
            Math.max(current, min),
            max,
        );

        // Clear price + booking fee (need re-quote)
        booking.confirmedBooking.price = 0;
        booking.confirmedBooking.bookingFee = 0;

        setQuoteAttempted(false);
        setQuoteValid(false);
        setQuoteError(null);
        setQuoteNotice(null);
        setQuoteMeta(null);

        setConfirmedClub(club);
        setCourses(courses);
        setBooking(new TeeTimeBooking(booking));
    };

    const onChangeConfirmedCourse = (value) => {
        if (value === null) {
            booking.confirmedBooking.course = null;
        } else {
            booking.confirmedBooking.course =
                courses.find(({ _id }) => String(_id) === String(value)) ??
                null;
        }

        booking.confirmedBooking.price = 0;
        booking.confirmedBooking.bookingFee = 0;

        setQuoteAttempted(false);
        setQuoteValid(false);
        setQuoteError(null);
        setQuoteNotice(null);
        setQuoteMeta(null);

        setBooking(new TeeTimeBooking(booking));
    };

    const updateContract = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to consume balls against the contract for this booking?",
        );
        if (confirmed === false) return;

        try {
            await booking.updateContract(
                availableContracts[0]._id,
                booking.confirmedBooking.players,
            );
            booking.contract = availableContracts[0];
            notification("success", "Contract updated & balls consumed");
            setBooking(new TeeTimeBooking(booking));
            setAvailableContracts([]);
            setAvailableContractsExplain([]);
            await getBooking(); // ✅ refresh whole state from server
        } catch (error) {
            const messages = error?.response?.data?.errors;
            const message =
                Array.isArray(messages) && messages.length > 0
                    ? messages.join(", ")
                    : "Failed to update contract";

            notification("error", message);
        }
    };

    const deleteContract = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to return the consumed balls to the contract available pool?",
        );
        if (confirmed === false) return;

        try {
            await booking.deleteContract(
                booking?.confirmedBooking?.players ?? booking.players,
            );
            booking.contract = null;
            notification("success", "Contract Removed from booking");
            setBooking(new TeeTimeBooking(booking));
        } catch (_) {
            notification("error", "Failed to remove contract from booking");
        }
    };

    const showRefundContract = () => {
        if (
            booking.contract !== null &&
            booking.contract.allocated !== null &&
            booking.status === "cancelled"
        ) {
            return (
                <div className={styles.choice}>
                    <>
                        <p class='mb-3'>
                            This booking was made using a contract and balls
                            were consumed. The booking has since been cancelled.
                            Would you like to return the balls to the available
                            pool?
                        </p>
                        <Button
                            onClick={deleteContract}
                            primary
                            className='theme'
                        >
                            Return balls to pool
                        </Button>
                    </>
                </div>
            );
        }
    };

    const handleChangeAccordion = (e, titleProps) => {
        const { index } = titleProps;
        setActiveAccordion(activeAccordion === index ? -1 : index);
    };

    const showConsumeContract = () => {
        const headers = [
            { key: "check", text: "Check" },
            { key: "data", text: "Data" },
            { key: "passFail", text: "Pass / Fail" },
        ];

        const data = availableContractsExplain.map((check) => {
            const row = {
                check: {
                    value: check.check,
                },
                data: {
                    value: check.data,
                },
                passFail: {
                    value: check.passFail ? (
                        <Icon name='check' />
                    ) : (
                        <Icon name='times' />
                    ),
                },
            };
            return row;
        });

        if (availableContracts.length === 0) {
            if (!booking.contract && !booking.voucher) {
                return (
                    <Accordion styled className='mt-3'>
                        <AccordionTitle
                            active={activeAccordion === 0}
                            index={0}
                            onClick={handleChangeAccordion}
                        >
                            <Icon name='dropdown' />
                            Why can't I convert this booking to use a contract?
                        </AccordionTitle>
                        <AccordionContent active={activeAccordion === 0}>
                            <DataTable
                                //loading={this.state.loading}
                                headers={headers}
                                data={data}
                                hideSearch={true}
                                hideResultsCount={true}
                                hideExport={true}
                                pagination={false}
                                noSorting={true}
                            />
                        </AccordionContent>
                    </Accordion>
                );
            }
            return null;
        }

        return (
            <div className={styles.choice}>
                <>
                    <p>
                        This course has available balls on the requested date.
                        Would you like to consume balls from the contract for
                        this booking?
                    </p>
                    <p class='mt-3 mb-3'>
                        <b>Contract Name: </b>
                        {availableContracts[0].name}
                        <br />
                        <b>Available Balls: </b>
                        {availableContracts[0].available === null
                            ? "Unlimited"
                            : availableContracts[0].available}
                    </p>
                    <Button onClick={updateContract} primary className='theme'>
                        Consume balls
                    </Button>
                </>
            </div>
        );
    };

    const statusTab = () => {
        return (
            <>
                <Segment vertical>
                    <div className='row skinny'>
                        <div className='col'>
                            <ValidationError field='status' />
                            <h3>Booking status</h3>
                            <label className='with-input'>Status</label>
                            <Select
                                fluid
                                value={booking.status}
                                onChange={(_, { value }) =>
                                    onChangeStatus(value)
                                }
                                options={statuses}
                            />
                            <p className='mt-3'>
                                {statusDescriptions[booking.status]}
                            </p>
                            {booking.status === "cancelled" && (
                                <>
                                    <ValidationError field='cancellationReason' />
                                    <label className='with-input'>
                                        Cancellation reason
                                    </label>
                                    <Select
                                        clearable
                                        fluid
                                        placeholder='Cancellation reason'
                                        value={
                                            booking.cancellationReason || null
                                        }
                                        onChange={(_, { value }) =>
                                            onChangeCancellationReason(value)
                                        }
                                        options={cancellationReasons}
                                    />
                                </>
                            )}
                            <p className='mt-3'>
                                <b>
                                    Note: The customer will be notified of any
                                    status changes.
                                </b>
                            </p>
                        </div>
                    </div>
                </Segment>
                <Segment vertical className='text-right'>
                    <Button
                        primary
                        className='theme'
                        loading={saving}
                        onClick={save}
                    >
                        Save
                    </Button>
                </Segment>
            </>
        );
    };

    const onAddInternalNote = async (value) => {
        const newNote = await booking.storeInternalNote(value);
        setInternalNotes([newNote, ...internalNotes]);
    };

    const onAddCustomerNote = async (value) => {
        const newNote = await booking.storeCustomerNote(value);
        setCustomerNotes([newNote, ...customerNotes]);
    };

    const paymentTab = () => {
        const currencySymbol =
            confirmedClub?.currency?.symbol ?? booking.currency?.symbol ?? "£";

        const refundPrice = booking.hasConfirmedBooking
            ? booking?.confirmedBooking?.price
            : booking?.price;

        const refundPriceText =
            typeof refundPrice === "number"
                ? `${currencySymbol}${formatNumberAsPrice(refundPrice)}`
                : "Unknown";
        return (
            <>
                <Segment vertical>
                    <div className='row'>
                        <div className='col'>
                            <label className='with-input'>Payment link</label>
                            <Input
                                fluid
                                placeholder='Payment link'
                                value={booking.paymentLink || ""}
                                onChange={({ target }) =>
                                    onChangePaymentLink(target.value)
                                }
                            />
                        </div>
                        <div className='col'>
                            <ValidationError field='paymentStatus' />
                            <label className='with-input'>Payment status</label>
                            <Select
                                fluid
                                value={booking.paymentStatus}
                                onChange={(_, { value }) =>
                                    onChangePaymentStatus(value)
                                }
                                options={paymentStatuses}
                            />
                            {booking.refundedAt && (
                                <Message info>
                                    <Message.Header>
                                        Refund issued
                                    </Message.Header>
                                    <p className='mb-0'>
                                        This booking was refunded{" "}
                                        {format(
                                            booking.refundedAt instanceof Date
                                                ? booking.refundedAt
                                                : new Date(booking.refundedAt),
                                            "dd LLLL yyyy, HH:mm",
                                        )}{" "}
                                        {booking.hasConfirmedBooking
                                            ? `and the Green Fee Credit Price listed in the confirmed booking (${refundPriceText}) was refunded to the members Green Fee Credit balance.`
                                            : `and the originally requested booking quoted Credit price (${refundPriceText}) was refunded to the members Green Fee Credit balance.`}
                                    </p>
                                </Message>
                            )}

                            {booking.paymentStatus === "refunded" &&
                                booking.contract !== null &&
                                booking.isCreditBooking === true &&
                                booking.voucher === null &&
                                !booking.refundedAt && (
                                    <Message warning>
                                        <Message.Header>
                                            Green Fee Credit refund will be
                                            issued
                                        </Message.Header>
                                        <p className='mb-0'>
                                            Changing the payment status to{" "}
                                            <b>Refunded</b> will issue a Green
                                            Fee Credit refund of{" "}
                                            <b>{refundPriceText}</b> to the
                                            member.
                                        </p>
                                    </Message>
                                )}
                        </div>
                    </div>
                </Segment>
                <Segment vertical className='text-right'>
                    <Button
                        primary
                        className='theme'
                        loading={saving}
                        onClick={save}
                    >
                        Save
                    </Button>
                </Segment>
            </>
        );
    };

    const numberOfPlayers = () => {
        if (booking.players > 8) {
            return booking.players + "+";
        }

        return booking.players;
    };

    const listChoices = () => {
        return (
            <div className={styles.choice}>
                <h3>Requested club</h3>
                {booking.choices.map((choice, index) => {
                    return (
                        <div key={index}>
                            <p className='m-0'>
                                <Link
                                    key={index}
                                    to={`/golf-clubs/${choice.course.club._id}`}
                                >
                                    {choice.course.club.name}
                                </Link>
                            </p>
                            <p className='m-0'>{choice.course.name}</p>
                            <p className='m-0'>
                                {choice.course.club.email ?? (
                                    <i>Club email not available</i>
                                )}
                            </p>
                            {clubContacts(choice.course.club)}
                        </div>
                    );
                })}
            </div>
        );
    };

    const listNearby = () => {
        return (
            <div className={styles.choice}>
                <h3>Alternative clubs (within 60 miles)</h3>
                {nearby.length === 0 ? (
                    <p>No alternative clubs were found</p>
                ) : (
                    nearby.map((club, index) => {
                        return (
                            <div key={index} className='mt-3'>
                                <p className='m-0'>
                                    <Link to={`/golf-clubs/${club._id}`}>
                                        {club.name}
                                    </Link>
                                </p>
                                <p className='m-0'>
                                    {club.distance} miles away
                                </p>
                            </div>
                        );
                    })
                )}
            </div>
        );
    };

    const updateConfirmedBooking = async () => {
        try {
            await booking.updateConfirmedBooking();
            getBooking();
            notification("success", "Booking updated");
        } catch (error) {
            // still dispatch semantic ValidationErrors when it's that format
            handleValidationErrors(error);

            const data = error?.response?.data;

            // errors can be: []  OR  { user: [] } (or other keyed arrays)
            const rawErrors = data?.errors;

            let messages = [];

            if (Array.isArray(rawErrors)) {
                messages = rawErrors;
            } else if (rawErrors && typeof rawErrors === "object") {
                messages = Object.values(rawErrors).flat().filter(Boolean);
            }

            if (messages.length > 0) {
                // make it obvious (and readable)
                notification("error", messages.join("\n"));
            } else {
                notification("error", "Something went wrong");
            }
        }
    };

    const showRestrictionNotice = () => {
        if (booking.voucher !== null) {
            return (
                <p className='mt-3'>
                    <b>
                        This is a voucher booking, therefore some fields have
                        been restricted
                    </b>
                </p>
            );
        }

        if (booking.isCreditBooking === true) {
            return (
                <p className='mt-3'>
                    <b>
                        This is a credit booking, therefore some fields have
                        been restricted
                    </b>
                </p>
            );
        }

        if (booking.contract !== null) {
            return (
                <p className='mt-3'>
                    <b>
                        This booking is associated with a contract, therefore
                        some fields have been restricted
                    </b>
                </p>
            );
        }

        return null;
    };

    const getConfirmedPlayersLimits = () => {
        // Voucher: fixed players, cannot edit
        if (booking?.voucher) {
            const fixed = booking.voucher.players ?? 0;
            return { min: fixed, max: fixed, disabled: true, mode: "voucher" };
        }

        // Prefer confirmed club if present, else requested club
        const club =
            confirmedClub ??
            booking?.confirmedBooking?.course?.club ??
            booking?.choices?.[0]?.course?.club ??
            null;

        const isCredit =
            booking?.isCreditBooking === true || booking?.contract !== null;

        const min = isCredit
            ? club?.bookingCreditMinPlayers
            : club?.bookingCashMinPlayers;

        const max = isCredit
            ? club?.bookingCreditMaxPlayers
            : club?.bookingCashMaxPlayers;

        // Sensible fallbacks if club values are missing for any reason
        const fallback = isCredit ? { min: 2, max: 4 } : { min: 1, max: 100 };

        return {
            min: typeof min === "number" ? min : fallback.min,
            max: typeof max === "number" ? max : fallback.max,
            disabled: false,
            mode: isCredit ? "credit" : "cash",
        };
    };

    const isVoucherFlow = booking?.voucher !== null;

    // “Credit flow” is still only non-voucher credit bookings (UI restrictions etc)
    const isCreditFlow =
        !isVoucherFlow &&
        (booking?.isCreditBooking === true || booking?.contract !== null);

    const isCashFlow = !isVoucherFlow && !isCreditFlow;

    // Calendar behaviour: vouchers WITH a contract must behave like credit
    const isCreditBookingForCalendar =
        isCreditFlow || (isVoucherFlow && booking?.contract !== null);

    const getActiveConfirmedClub = () => {
        // confirmedClub state is best when user changes club in this screen
        return (
            confirmedClub ??
            booking?.confirmedBooking?.course?.club ??
            booking?.choices?.[0]?.course?.club ??
            null
        );
    };

    const getActiveConfirmedCourse = () => {
        // In the editor, only use the confirmedBooking value (even if null)
        if (showConfirmedBookingEditor) {
            return booking?.confirmedBooking?.course ?? null;
        }

        // Outside editor, fallback is fine
        return booking?.choices?.[0]?.course ?? null;
    };

    const getPlayersLimitsForFlow = () => {
        if (booking?.voucher) {
            const fixed = booking.voucher.players ?? 0;
            return { min: fixed, max: fixed, disabled: true };
        }

        const club = getActiveConfirmedClub();
        const fallback = isCreditFlow
            ? { min: 2, max: 4 }
            : { min: 1, max: 100 };

        const min = isCreditFlow
            ? club?.bookingCreditMinPlayers
            : club?.bookingCashMinPlayers;
        const max = isCreditFlow
            ? club?.bookingCreditMaxPlayers
            : club?.bookingCashMaxPlayers;

        return {
            min: typeof min === "number" ? min : fallback.min,
            max: typeof max === "number" ? max : fallback.max,
            disabled: false,
        };
    };

    const hasValidClubAndCourse = () => {
        const club = getActiveConfirmedClub();
        const course = getActiveConfirmedCourse();
        return !!club?._id && !!course?._id;
    };

    const buildDraftConfirmedBookingFromDefaults = () => {
        const course = booking?.choices?.[0]?.course ?? null;

        const date = booking?.date ? new Date(booking.date) : null;
        if (date) date.setHours(12);

        // booking.timeslot is like "12:00 - 13:00"
        const time =
            booking?.timeslot && typeof booking.timeslot === "string"
                ? booking.timeslot.split(" ")[0] // "12:00"
                : booking?.time ?? null;

        return {
            date,
            time,
            players: booking?.players ?? 1,
            price: booking?.price ?? 0,
            bookingFee: booking?.bookingFee ?? 0,
            course,
        };
    };

    const confirmBooking = () => {
        if (
            booking.hasConfirmedBooking === false &&
            showConfirmedBookingEditor === false
        ) {
            return (
                <>
                    <Button
                        primary
                        className='theme mt-3'
                        loading={addingConfirmedBooking}
                        disabled={addingConfirmedBooking}
                        onClick={addConfirmedBooking}
                    >
                        Add Confirmed Booking
                    </Button>

                    {addingConfirmedBooking && (
                        <Message info className='mt-2'>
                            Loading booking data...
                        </Message>
                    )}
                </>
            );
        }

        // Ensure we have a draft when editor is open
        if (!booking.confirmedBooking) {
            booking.confirmedBooking = buildDraftConfirmedBookingFromDefaults();
        }

        if (!booking?.confirmedBooking) return null;

        const limits = getPlayersLimitsForFlow();
        const club = getActiveConfirmedClub();
        const course = getActiveConfirmedCourse();
        const showDateTime = hasValidClubAndCourse();
        const hasSelectedCourse = !!course?._id;

        const courseOptions = [
            { key: "please", text: "Please choose a course", value: null },
            ...courses.map((c, index) => ({
                key: index,
                text: c.name,
                value: String(c._id),
            })),
        ];

        const playersLabelHint = booking.voucher
            ? `(fixed at ${limits.min})`
            : `(min ${limits.min}, max ${limits.max})`;

        const playersInput = (
            <Segment vertical>
                <label className='with-input'>
                    No. of players {playersLabelHint}
                </label>
                <NumberInput
                    placeholder='No. of players'
                    value={booking.confirmedBooking.players}
                    onChange={onChangeConfirmedPlayers}
                    min={limits.min}
                    max={limits.max}
                    disabled={booking.voucher !== null}
                />
            </Segment>
        );

        const clubCourseBlock = (
            <>
                <Segment vertical>
                    <label className='with-input'>Club</label>
                    <GolfClubSearchSelect
                        disabled={!isCashFlow}
                        value={club?._id ?? null}
                        onChange={onChangeConfirmedClub}
                    />
                </Segment>

                <Segment vertical>
                    <label className='with-input'>Course</label>
                    <Select
                        disabled={!isCashFlow}
                        search
                        placeholder='Please choose a course'
                        value={course?._id ? String(course._id) : null}
                        onChange={(_, { value }) =>
                            onChangeConfirmedCourse(value)
                        }
                        options={courseOptions}
                    />
                </Segment>
            </>
        );

        const dateTimeBlock = !showDateTime ? null : (
            <Segment vertical>
                <label className='with-input'>Date & time</label>
                <CourseAvailabilityCalendar
                    dateValue={booking.confirmedBooking.date}
                    timeValue={booking.confirmedBooking.time}
                    member={booking.user._id}
                    voucher={booking.voucher?._id}
                    course={course._id}
                    onChangeDate={onChangeConfirmedDate}
                    onChangeTime={onChangeConfirmedTime}
                    onOverrideChange={onChangeConfirmedOverride}
                    isCreditBooking={isCreditBookingForCalendar}
                    bookingId={booking._id}
                    showTimeInput
                />
            </Segment>
        );

        const shouldShowPriceBlocks =
            showDateTime &&
            quoteLoading === false &&
            (confirmedOverrideAvailableDates === true ||
                quoteValid === true ||
                quoteAttempted === false); // ✅ initial load / before first quote

        const priceBlockCashOrCredit = !shouldShowPriceBlocks ? null : (
            <>
                <Segment vertical>
                    <ValidationError field='price' />
                    <label className='with-input'>
                        Green Fee Price (players * price)
                    </label>
                    <NumberInput
                        icon={club?.currency?.icon ?? ""}
                        iconPosition='left'
                        placeholder='Price'
                        fluid
                        decimal
                        value={booking.confirmedBooking.price}
                        onChange={onChangeConfirmedPrice}
                    />
                    {isCreditFlow &&
                        (() => {
                            const adj = getCreditAdjustmentInfo();
                            if (!adj.show) return null;

                            return (
                                <>
                                    <p className='mt-2 mb-1'>
                                        <b>{adj.priceDifferenceText}</b>
                                    </p>
                                    <p className='mb-0'>
                                        New GFC balance:{" "}
                                        <b>{adj.newBalanceText}</b>
                                    </p>

                                    {!adj.canProcess && (
                                        <Message warning className='mt-2'>
                                            The member does not have enough
                                            Green Fee Credit to apply this
                                            amendment.
                                        </Message>
                                    )}
                                </>
                            );
                        })()}
                </Segment>

                {isCashFlow && (
                    <Segment vertical>
                        <ValidationError field='bookingFee' />
                        <label className='with-input'>
                            Booking fee (total)
                        </label>
                        <NumberInput
                            icon={"gbp"}
                            decimal
                            iconPosition='left'
                            placeholder='Booking fee'
                            fluid
                            value={booking.confirmedBooking.bookingFee}
                            onChange={onChangeConfirmedBookingFee}
                        />
                    </Segment>
                )}
            </>
        );

        const creditAdj = isCreditFlow
            ? getCreditAdjustmentInfo()
            : { show: false, canProcess: true };

        const canSave =
            hasSelectedCourse &&
            (confirmedOverrideAvailableDates === true || quoteValid === true) &&
            (!creditAdj.show || creditAdj.canProcess === true);

        const saveButton = (
            <Segment vertical>
                <Button
                    primary
                    className='theme'
                    disabled={!canSave}
                    onClick={updateConfirmedBooking}
                >
                    Save
                </Button>
            </Segment>
        );

        // FLOW: VOUCHER
        if (isVoucherFlow) {
            return (
                <Segment vertical>
                    <div className='row skinny'>
                        <div className='col'>
                            {showRestrictionNotice()}
                            <ValidationError field='confirmedBooking' />

                            {clubCourseBlock /* disabled */}
                            {playersInput /* disabled */}
                            {dateTimeBlock /* editable */}
                            {saveButton}
                        </div>
                    </div>
                </Segment>
            );
        }

        // FLOW: CREDIT
        if (isCreditFlow) {
            return (
                <Segment vertical>
                    <div className='row skinny'>
                        <div className='col'>
                            {showRestrictionNotice()}
                            <ValidationError field='confirmedBooking' />

                            {clubCourseBlock /* disabled */}
                            {playersInput /* editable */}
                            {dateTimeBlock /* editable */}
                            {quoteLoading &&
                                confirmedOverrideAvailableDates === false && (
                                    <Message info className='mt-2'>
                                        We&apos;re currently fetching the latest
                                        prices...
                                    </Message>
                                )}
                            {quoteNotice &&
                                confirmedOverrideAvailableDates === false && (
                                    <Message warning className='mt-2'>
                                        {quoteNotice}
                                    </Message>
                                )}
                            {
                                priceBlockCashOrCredit /* visible, editable (override-only rules to be added with quote plumbing) */
                            }
                            {saveButton}
                        </div>
                    </div>
                </Segment>
            );
        }

        // FLOW: CASH
        return (
            <Segment vertical>
                <div className='row skinny'>
                    <div className='col'>
                        {showRestrictionNotice()}
                        <ValidationError field='confirmedBooking' />

                        {clubCourseBlock /* editable */}
                        {playersInput /* editable */}
                        {dateTimeBlock /* editable */}
                        {quoteLoading &&
                            confirmedOverrideAvailableDates === false && (
                                <Message info className='mt-2'>
                                    We&apos;re currently fetching the latest
                                    prices...
                                </Message>
                            )}
                        {quoteNotice &&
                            confirmedOverrideAvailableDates === false && (
                                <Message warning className='mt-2'>
                                    {quoteNotice}
                                </Message>
                            )}
                        {priceBlockCashOrCredit /* visible */}
                        {!hasSelectedCourse && (
                            <Message warning className='mt-2'>
                                Please select a course before saving the
                                booking.
                            </Message>
                        )}
                        {saveButton}
                    </div>
                </div>
            </Segment>
        );
    };

    const deleteBooking = async () => {
        const confirm = window.confirm(
            "Are you sure you want to delete this tee time request?",
        );
        if (confirm === true) {
            try {
                await booking.delete();
                history.push("/tee-time-requests");
                notification("success", "Tee time deleted");
            } catch (_) {
                notification("error", "Something went wrong");
            }
        }
    };

    const watchBooking = async () => {
        const confirm = window.confirm(
            "Are your sure you want to watch this teetime?",
        );
        if (confirm === true) {
            try {
                await booking.watch();
                booking.watchers.push(user);
                setBooking(booking);
                notification("success", "You are now watching this tee time");
            } catch (_) {
                notification("error", "Failed to watch tee time");
            }
        }
    };

    const showWatchButton = () => {
        if (user.isWatchingTeeTime(booking)) {
            return (
                <Label as='a' className='mr-2'>
                    Watching
                </Label>
            );
        }

        return (
            <Button primary className='theme' onClick={watchBooking}>
                Watch
            </Button>
        );
    };

    const claimTeeTime = async () => {
        const confirm = window.confirm(
            "Are you sure you want to claim this teetime?",
        );
        if (confirm === true) {
            try {
                await booking.claim();
                booking.claimedBy = user;
                setBooking(booking);
                notification("success", "Tee time claimed");
            } catch (_) {
                notification("error", "Failed to claim tee time");
            }
        }
    };

    const showClaimedBy = () => {
        if (typeof booking.claimedBy !== "undefined") {
            return (
                <Label as='a' image className='mr-2'>
                    <img src={User.profileImageUrlForUser(booking.claimedBy)} />
                    Claimed by {booking.claimedBy.name}
                </Label>
            );
        }

        return null;
    };

    const showClaimButton = () => {
        if (user.hasClaimedTeeTime(booking) === false) {
            return (
                <Button primary className='theme' onClick={claimTeeTime}>
                    Claim
                </Button>
            );
        }
    };

    const onChangeTab = (key) => {
        if (key === "customerNotes") {
            getCustomerNotes();
            booking.markCustomerNotesRead();
            booking.unreadMessages = 0;
            setBooking(booking);
        }
        if (key === "internalNotes") {
            getInternalNotes();
        }
    };

    const customerNotesTabText = () => {
        const showUnreadCount =
            user.isWatchingTeeTime(booking) || user.hasClaimedTeeTime(booking);
        if (showUnreadCount && booking.unreadMessages > 0) {
            return (
                <div>
                    Customer messages{" "}
                    <Label circular color='red' className='ml-1' size='small'>
                        {booking.unreadMessages}
                    </Label>
                </div>
            );
        }

        return "Customer messages";
    };

    const showQuotedPrice = () => {
        const { price = null } = booking;
        if (price === null) {
            return <i>No price available</i>;
        }

        let priceString = `${
            confirmedClub?.currency?.symbol ?? "£"
        }${formatNumberAsPrice(price)}`;
        if (booking.bookingFee > 0) {
            priceString += ` (+ £${formatNumberAsPrice(
                booking.bookingFee,
            )} booking fee)`;
        }

        return priceString;
    };

    const showContractPaymentStatusWarning = () => {
        const statuses = [
            "pay mashie now",
            "paid",
            "refunded",
            "no payment required",
        ];
        if (
            booking.contract !== null &&
            booking.isCreditBooking === false &&
            statuses.includes(booking.paymentStatus) === false
        ) {
            return (
                <p className='mb-5'>
                    <b>Warning: </b>This booking is associated with a contract,
                    but has a payment status of {booking.paymentStatus}.
                </p>
            );
        }
    };

    const body = () => {
        if (loading === true) {
            return <CenterLoader />;
        }

        return (
            <div className='container'>
                <div className='row skinny mb-3'>
                    <div className='col-12 mb-3'>
                        <h2>Tee Time Request</h2>
                    </div>
                    <div className='col-12 mb-3'>
                        {showClaimedBy()}
                        {showClaimButton()}
                        {showWatchButton()}
                    </div>
                    <div className='col-12'>
                        <Dropdown
                            text='Options'
                            icon='cog'
                            floating
                            labeled
                            button
                            className='icon'
                        >
                            <Dropdown.Menu>
                                <Dropdown.Header icon='cog' content='Options' />
                                <Dropdown.Divider />
                                <Dropdown.Item
                                    icon='trash'
                                    text='Delete'
                                    onClick={deleteBooking}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                <div className='row skinny mb-5'>
                    <div className='col-4'>
                        <div className={styles.choice}>
                            <h3>Requested Booking Details</h3>
                            <MemberChip member={booking.user} />
                            <p className='mt-2'>
                                <span>
                                    <b>Booking reference: </b>
                                </span>
                                <span>{booking.bookingReference}</span>
                            </p>
                            <p className='mt-2'>
                                <span>
                                    <b>Request made: </b>
                                </span>
                                <span>
                                    {format(
                                        booking.createdAt,
                                        "dd LLLL yyyy, HH:mm",
                                    ) +
                                        " (" +
                                        formatDistanceToNow(booking.createdAt) +
                                        ")"}
                                </span>
                            </p>

                            {booking.bookingAutoRequested && (
                                <p className='mt-1'>
                                    <Label
                                        style={{
                                            color: "white",
                                            backgroundColor: "#00b5ad",
                                        }}
                                    >
                                        Date/time check sent to club
                                    </Label>
                                </p>
                            )}
                            <p className='mt-1'>
                                <b>Requested date & time:</b>{" "}
                                {format(booking.date, "dd LLLL yyyy")},{" "}
                                {booking.timeslot}
                            </p>
                            <p className='mt-1'>
                                <b>No. of players:</b> {numberOfPlayers()}
                            </p>
                            <p className='mt-1'>
                                <b>Additional requests:</b>{" "}
                                {booking.additionalRequests.length > 0 ? (
                                    booking.additionalRequests.join(", ")
                                ) : (
                                    <i>None</i>
                                )}
                            </p>
                            {!booking.voucher && (
                                <p className='mt-1'>
                                    <b>
                                        Original{" "}
                                        {booking.isCreditBooking
                                            ? "Credit"
                                            : "Quoted"}{" "}
                                        price:{" "}
                                    </b>
                                    {showQuotedPrice()}
                                </p>
                            )}
                            {booking.isCreditBooking === true &&
                                !booking.voucher &&
                                typeof booking.creditPaid === "number" && (
                                    <p className='mt-1'>
                                        <b>Green Fee Credit paid:</b>{" "}
                                        {`${
                                            confirmedClub?.currency?.symbol ??
                                            "£"
                                        }${formatNumberAsPrice(
                                            booking.creditPaid,
                                        )}`}
                                    </p>
                                )}
                            <p
                                className='mt-1'
                                style={{ whiteSpace: "pre-line" }}
                            >
                                <b>Customer added notes:</b>{" "}
                                {booking.notes && booking.notes.length > 0 ? (
                                    booking.notes
                                ) : (
                                    <i>None</i>
                                )}
                            </p>
                            <p className='mt-1'>
                                <b>Booking type:</b>{" "}
                                {booking.isCreditBooking
                                    ? booking.voucher
                                        ? "Green Fee Credit (Voucher used)"
                                        : "Green Fee Credit"
                                    : booking.voucher
                                    ? "Green Fee (Voucher used)"
                                    : "Green Fee"}
                            </p>
                            <p className='mt-1'>
                                <b>Contract:</b>{" "}
                                {booking.contract ? (
                                    <Link
                                        to={`/partner-club-contracts/${booking.contract._id}`}
                                    >
                                        {booking.contract.name}
                                    </Link>
                                ) : (
                                    <i>None</i>
                                )}
                            </p>
                            <p className='mt-1'>
                                <b>Voucher:</b>{" "}
                                {booking.voucher ? (
                                    <Link
                                        to={`/course-vouchers/${booking.voucher._id}`}
                                    >
                                        View voucher
                                    </Link>
                                ) : (
                                    <i>None</i>
                                )}
                            </p>
                        </div>
                        {showConsumeContract()}
                        {showRefundContract()}
                    </div>
                    <div className='col-4'>{listChoices()}</div>
                    {booking.isCreditBooking === false ||
                        booking.voucher === null ||
                        (booking.contract === null && (
                            <div className='col-4'>{listNearby()}</div>
                        ))}
                </div>
                {showContractPaymentStatusWarning()}
                <Tabs
                    defaultActiveKey='confirmedBooking'
                    id='tabs'
                    onSelect={onChangeTab}
                >
                    <Tab eventKey='confirmedBooking' title='Confirmed Booking'>
                        <div className='row skinny mb-3'>
                            <div className='col'>{confirmBooking()}</div>
                        </div>
                    </Tab>
                    <Tab eventKey='status' title='Status'>
                        {statusTab()}
                    </Tab>
                    <Tab
                        eventKey='customerNotes'
                        title={customerNotesTabText()}
                    >
                        <Notes
                            placeholder='Type to send a message to member'
                            notes={customerNotes}
                            onSave={onAddCustomerNote}
                        />
                    </Tab>
                    <Tab eventKey='internalNotes' title='Internal notes'>
                        <Notes
                            placeholder='Type to add a new note'
                            notes={internalNotes}
                            onSave={onAddInternalNote}
                        />
                    </Tab>
                    <Tab eventKey='payment' title='Payment'>
                        {paymentTab()}
                    </Tab>
                </Tabs>
            </div>
        );
    };

    return (
        <>
            <div className='d-flex main'>
                <Header history={history} />
                {body()}
            </div>
            <Footer />
        </>
    );
};

function mapStateToProps(state) {
    return {
        user: state.user,
        notification: state.notification,
        validation: state.validation,
    };
}

export default connect(mapStateToProps)(Show);
